<style src="./StockMap.scss" lang="scss" scoped></style>
<template>
  <section class="stock-map">
    <ul class="grid-list-container">
      <li
        class="stock-grid-row"
        v-for="(item, itemIdx) in list"
        :key="itemIdx"
        @click="editItem({ item, itemIdx })">
        <div class="info-1">
          <span class="pativo">{{ item.pativo }}</span>
          <span class="ncomercial">{{ item.comercialName }} <small>{{ item.codProd }}</small></span>
          <span class="lab">{{ item.lab }}</span>

          <div class="item-status">
            <span v-if="item.fisicalForm" class="fisicalType">{{ item.fisicalForm.unityType }}</span>
            <span v-show="item.isSuspended" class="suspended">SUSPENSO</span>
            <span v-show="item.isPreferred" class="preferred"><icon-star class="icon-preferred" />PREFERENCIAL</span>
          </div>
        </div>

        <div class="codes-column">
          <editable-tag-label
            title="GGREM"
            hint="Código GGREM"
            v-model="item.ggremCode"
            @save-edition="(v) => updateGgrem(v, item)" />
          <editable-tag-label
            hint="Código na Anvisa"
            title="RMS"
            v-model="item.rmsCode"
            @save-edition="(v) => updateRms(v, item)" />
          <editable-tag-label
            hint="Código do fornecedor"
            title="COD.FORN."
            v-model="item.supplierCode"
            @save-edition="(v) => updateSupplier(v, item)" />
        </div>

        <div class="info-2">
          <div class="column-documents">
            <icon-anvisa-rms
              class="icon"
              v-for="(lookupAnvisa, lookupAnvisaIdx) in item.lookupAnvisa"
              :key="lookupAnvisaIdx"
              @click.stop.native="openAnvisaRms(lookupAnvisa.documentFile.fileName)" />
            
            <icon-cbpf
              class="icon"
              v-for="(lookupCbpf, lookupCbpfIdx) in item.lookupCbpf"
              :key="lookupCbpfIdx"
              @click.stop.native="openCbpf(lookupCbpf.documentFile.fileName)" />
          </div>

          <div class="commands">
            <button
              type="button"
              class="button-edit-max"
              @click.stop="editMaxPrice(item, itemIdx)"
              v-show="!item.ggremCode">
              <icon-edit class="icon"/>
              <span>EDITAR MÁXIMO</span>
            </button>
          </div>
        </div>

        <div class="info-3">
          <span class="title">CUSTO</span>
          <span class="cost"><small>R$</small>{{ item.cost | CurrencyBR }}</span>
          <div
            class="max-price icon-aside-show"
            :title="item.ggremCode"
            v-show="!!item.ggremCode">
            <small>MAX R$</small>
            <span>{{ item.lookupCmed ? item.lookupCmed.computedValue : '' | CurrencyBR }}</span>
            <div class="icon-aside" @click.stop="editMaxPrice(item, itemIdx)">
              <icon-edit class="icon"/>
            </div>
          </div>
        </div>

        <div class="info-4">
          <span class="title">ESTOQUE</span>
          <span class="stock">{{ item.stockQuantity | DecimalNumber }}</span>
          <span class="last-buy"><icon-calendar class="icon"/>{{ item.lastBuyingDate | FriendlyDate }}</span>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import { ButtonRemove } from '@/components/primitives'
import { IconEdit, IconLock, IconCalendar, IconAnvisaRms, IconCbpf, IconStar } from '@/components/primitives/icons'
import { CurrencyBR, DecimalNumber, FriendlyDate } from '@/components/primitives/helpers/filters'
import EditableTagLabel from '../editable-tag-label/EditableTagLabel'

export default {
  name: 'StockMap',
  components: {
    ButtonRemove,
    IconEdit,
    IconLock,
    IconCalendar,
    IconAnvisaRms,
    IconCbpf,
    IconStar,
    EditableTagLabel
  },
  props: {
    list: {
      default: () => ([])
    }
  },
  data () {
    return {}
  },
  filters: {CurrencyBR, DecimalNumber, FriendlyDate},
  mounted () {},
  methods: {
    editMaxPrice (pItem, pItemIdx) {
      this.$emit('edit-max-price', { item: pItem, itemIndex: pItemIdx })
    },
    editItem ({ item, itemIdx }) {
      this.$emit('edit-item', { item, itemIdx })
    },
    openAnvisaRms (fileName) {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/rms/${fileName}`)
    },
    openCbpf (fileName) {
      const serverUrl = this.$store.getters['Login/SERVER_URL']
      window.open(`${serverUrl}/document/cbpf/${fileName}`)
    },
    updateGgrem (ggremCode, id) {
      this.updateItem(id, { ggremCode })
    },
    updateRms (rmsCode, id) {
      this.updateItem(id, { rmsCode })
    },
    updateSupplier (supplierCode, item) {
      this.updateItem(item, { supplierCode })
    },
    async updateItem (item, fieldInfo) {
      const payload = {
        id: item._id,
        ...fieldInfo
      }

      try {
        await this.$store.dispatch('Stock/SAVE_ITEM_EDITION', payload)
        this.$toasted.success('Atualização salva com sucesso!')
        item[Object.keys(fieldInfo)[0]] = Object.values(fieldInfo)[0]
      } catch (error) {
        this.$toasted.error(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/stock/components/stock-map/StockMap.vue